export interface PendingSource {
  id: string
  name: string
  city: string
  phone: string
  /** Why this seller's prices aren't in the table yet. */
  reason: string
}

/**
 * Aggregate, soil and rock sellers inside the search footprint whose prices
 * are NOT published online. Each needs a phone call, then manual entry.
 */
export const pendingSources: PendingSource[] = [
  {
    id: 'white-river',
    name: 'White River Aggregate Plant (CalPortland, A-487)',
    city: '31107 SE Enumclaw Chinook Pass, Enumclaw, WA',
    phone: '(360) 825-6204',
    reason:
      'Hardrock quarry — 5/8" and 1-1/4" minus quarry rock, 2-1/2" minus crushed fill, spalls, washed sand & gravel, pea rock, rip rap, railroad ballast, 1/2–4 man rockery. Ask the scale house for the FOB price list (same format as the DuPont sheet)',
  },
  {
    id: 'pacific-topsoils',
    name: 'Pacific Topsoils Inc. (8 yards)',
    city: 'Everett to Maple Valley, WA',
    phone: '(425) 337-2700',
    reason: 'Publishes delivered prices only — call for a you-haul rate over the scale',
  },
  {
    id: 'applied-organics',
    name: 'Applied Organics Landscape Supply',
    city: 'Woodinville, WA',
    phone: '(425) 485-9813',
    reason: 'Publishes delivered prices only — call for a you-haul rate over the scale',
  },
  {
    id: 'lloyd-enterprises',
    name: 'Lloyd Enterprises',
    city: 'Federal Way, WA',
    phone: '',
    reason: 'Pit-run, topsoil and rock quoted by phone',
  },
]
